import CourseMedia from "../assets/img/course-media.jpg";
import { resolveStrapiMediaUrl } from "./strapiMedia";

export function getLicenciaturaImageUrl(program) {
  const raw = program?.attributes?.ImagenLicenciatura?.data?.attributes?.url;
  return resolveStrapiMediaUrl(raw) ?? CourseMedia;
}

export function filterLicenciaturasWithAttributes(list) {
  return (list ?? []).filter((item) => item?.attributes);
}
